// extracted by mini-css-extract-plugin
export default {"device":"TopicBoundariesDemoVoice_device__jU1hF"};